import { z } from 'my-zod'

export const corporateFleetSiteEnum = z
  .enum([
    'Bass Creek',
    'Battleground',
    'Boats',
    'Burgdorf Tech Center',
    'CTX Engineering',
    'EFW St. Paul',
    'ERI-Havasu',
    'PPX-Phoenix',
    'Fernley',
    'Huntsville',
    'Medina',
    'Milford East',
    'Pinedale',
    'Monterrey',
    'Offsite',
    'Opole',
    'Osceola',
    'Plymouth',
    'Polaris Proving Grounds',
    'Polaris',
    'Roseau',
    'RQFacility',
    'Sandpoint-Timbersled',
    'SBS Storage',
    'Spirit Lake',
    'Sunnyvale',
    'Swiss Auto',
    'Taylor Dunn',
    'Vermillion',
    'Wyoming',
    'KLIM',
    'Polaris Vietnam',
    'Set-Up DLR',
    'Xchange'
  ])
  .setEnumLabels({
    Polaris: 'Polaris',
    Wyoming: 'Wyoming',
    Medina: 'Medina',
    RQFacility: 'R&Q Facility',
    Roseau: 'Roseau',
    'SBS Storage': 'SBS Storage',
    'Polaris Proving Grounds': 'Polaris Proving Grounds',
    Offsite: 'Offsite',
    Pinedale: 'Pinedale',
    Huntsville: 'Huntsville',
    'Spirit Lake': 'Spirit Lake',
    Osceola: 'Osceola',
    Monterrey: 'Monterrey',
    Opole: 'Opole',
    'Burgdorf Tech Center': 'Burgdorf Tech Center',
    'Bass Creek': 'Bass Creek',
    Plymouth: 'Plymouth',
    'CTX Engineering': 'CTX Engineering',
    'Milford East': 'Milford East',
    'ERI-Havasu': 'ERI-Havasu',
    'PPX-Phoenix': 'PPX-Phoenix',
    Sunnyvale: 'Sunnyvale',
    Battleground: 'Battleground',
    Fernley: 'Fernley',
    Vermillion: 'Vermillion',
    Boats: 'Boats',
    'Sandpoint-Timbersled': 'Sandpoint-Timbersled',
    'Swiss Auto': 'Swiss Auto',
    'Taylor Dunn': 'Taylor Dunn',
    'EFW St. Paul': 'EFW St. Paul',
    KLIM: 'KLIM',
    'Polaris Vietnam': 'Polaris Vietnam',
    'Set-Up DLR': 'Set-Up DLR',
    Xchange: 'Xchange'
  })
export const corporateFleetSites = corporateFleetSiteEnum.Values

export type corporateFleetSiteEnum = z.infer<typeof corporateFleetSiteEnum>

export const corporateFleetLocationEnum = {
  [corporateFleetSites['Wyoming']]: ['Inventory Location', 'WOTT Pavilion', 'Wyoming'],
  [corporateFleetSites['CTX Engineering']]: ['CTX Main', 'CTX Storage'],
  [corporateFleetSites['Polaris']]: ['To Be Processed'],
  [corporateFleetSites['Roseau']]: [
    'East Shed',
    'Inventory Location',
    'Miller Building',
    'Roseau Fair Grounds',
    'Roseau Miracle Express',
    'Offsite',
    'Roseau'
  ],
  [corporateFleetSites['Polaris Proving Grounds']]: ['Inventory Location'],
  [corporateFleetSites['Xchange']]: [
    'Bloomington',
    'Dallas',
    'St. Paul',
    'Haviland',
    'Huntsville',
    'Laracy',
    'Redlands',
    'Roseau',
    'Salt Lake City',
    'Spirit Lake/Milford',
    'St. Louis',
    'Syracuse',
    'Tacoma',
    'Wyoming'
  ]
}

export const corporateFleetLocations = z.enum(Object.values(corporateFleetLocationEnum).flat() as [string, ...string[]])
